import { computeEffectiveTaken, redemptionState, type MatchDetail } from '@brochure/shared'

// `computeEffectiveTaken`/`redemptionState` (packages/shared/src/tournament/cups.ts) vogliono `createdAt`
// in epoch ms per ordinare eventi e spostamenti; l'API restituisce ISO string. Unico punto di conversione,
// così sia la pagina partita pubblica sia il futuro cruscotto arbitro leggono lo stato nello stesso modo.
function withEpoch<T extends { createdAt: string }>(items: readonly T[]): (Omit<T, 'createdAt'> & { createdAt: number })[] {
  return items.map((item) => ({ ...item, createdAt: Date.parse(item.createdAt) }))
}

/** Bicchieri effettivamente presi per squadra, spostamenti compresi. */
export function takenCups(detail: MatchDetail): { home: Set<number>; away: Set<number> } {
  const events = withEpoch(detail.cupEvents)
  const rearrangements = withEpoch(detail.rearrangements)
  return {
    home: computeEffectiveTaken(events, rearrangements, detail.match.homeTeamId),
    away: computeEffectiveTaken(events, rearrangements, detail.match.awayTeamId),
  }
}

/** Squadra in fase del pareggio (tutti i bicchieri presi), se c'è; altrimenti `null`. */
export function losingTeamId(detail: MatchDetail): string | null {
  const events = withEpoch(detail.cupEvents)
  const rearrangements = withEpoch(detail.rearrangements)
  return redemptionState(events, rearrangements, detail.match.homeTeamId, detail.match.awayTeamId, detail.maxCups).losingTeamId
}

/** Squadra che tira il pareggio (bicchieri oro): come `losingTeamId`, ma `null` se il torneo non lo prevede
 * (`redemptionShot = false`: la partita si chiude appena una squadra ha tutti i bicchieri presi). */
export function redemptionTeamId(detail: MatchDetail): string | null {
  return detail.settings.redemptionShot ? losingTeamId(detail) : null
}
